<template>
  <div>
    <h2 class="text-center">
      Dettaglio cliente: {{ cliente && cliente.ragioneSociale }}
    </h2>
    <v-expansion-panels v-model="panel" class="pa-3">
      <v-expansion-panel key="0">
        <v-expansion-panel-header>Scheda cliente</v-expansion-panel-header>
        <v-expansion-panel-content>
          <scheda-cliente
            v-if="cliente"
            :idCliente="cliente._id"
            :dati="cliente"
            :readOnly="true"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel key="1">
        <v-expansion-panel-header>Scontrini</v-expansion-panel-header>
        <v-expansion-panel-content>
          <acquisti-card :raccolta="acquisti" :isDense="false" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel key="2">
        <v-expansion-panel-header>Allegati</v-expansion-panel-header>
        <v-expansion-panel-content>
          <allegati
            v-if="cliente"
            :idCliente="cliente._id"
            :allegati="cliente.allegati"
            :size="12"
            @change="onChangeFile"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel key="3">
        <v-expansion-panel-header>Lavorazioni</v-expansion-panel-header>
        <v-expansion-panel-content>
          <lavorazioni v-if="cliente" :idCliente="cliente._id" :size="12" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import clienti from "@/services/clientiService.js";
import fidelity from "@/services/fidelityService";
import SchedaCliente from "@/views/clienti/elementi/scheda";
import AcquistiCard from "@/views/clienti/elementi/dettagli/acquistiCard.vue";
import Allegati from "@/views/clienti/elementi/allegati";
import Lavorazioni from "@/views/clienti/elementi/lavorazioni";

export default {
  components: {
    SchedaCliente,
    AcquistiCard,
    Allegati,
    Lavorazioni,
  },
  mixins: [verificaLicenza],
  props: {
    idCliente: { type: String, default: "" },
  },
  data: () => ({
    cliente: null,
    acquisti: [],
    panel: 1,
  }),
  async mounted() {
    await this.gestioneToken();
    await this.refresh();
  },
  watch: {},
  computed: {},
  methods: {
    async refresh() {
      if (this.idCliente) {
        const cliente = await clienti.getCliente(this.idCliente);
        this.cliente = cliente;

        const elenco = await fidelity.cercaFidelityByCliente(
          "",
          this.idCliente
        );
        if (elenco.length === 0) return;
        for (let cc of elenco) {
          if (cc.raccoltaPunti.raccolta) {
            for (let r of cc.raccoltaPunti.raccolta) {
              this.acquisti.push(r);
            }
          }
        }
      }
    },
    async onChangeFile({ idCliente, tipo, payload }) {
      switch (tipo) {
        case "addFile":
        case "updateFile":
          await clienti.aggiornaAllegati(idCliente, payload);
          break;
        case "deleteFile":
          await clienti.eliminaAllegato(idCliente, payload);
          break;
        default:
          break;
      }
    },
  },
};
</script>
